document.addEventListener('DOMContentLoaded', () => {
    const body = document.body;
    const overlay = document.querySelector('.voting-popup-overlay');

    // ============================================
    // GOOGLE FORM CONFIG — apna values ahi bharo
    // ============================================
    const GOOGLE_FORM_ID = "1FAIpQLSfP3DXcLpfqsKFlZrHRK8v56EbiRz0R9S29R5ayOSQYZXOfvg";
    const ENTRY_FULL_NAME = "entry.1141024183";
    const ENTRY_EMAIL     = "entry.1689248119";
    const ENTRY_PRODUCT   = "entry.3348392";
    const ENTRY_VOTE_TYPE = "entry.630560154";

    const GOOGLE_FORM_ACTION_URL =
        `https://docs.google.com/forms/d/e/${GOOGLE_FORM_ID}/formResponse`;

    // ============================================
    // POPUP OPEN / CLOSE LOGIC
    // ============================================
    let activeVoteButton = null; // konsu button click thayu e track karva mate (vote-lock mate)

    document.querySelectorAll('.popup-opner-button').forEach((button) => {
        button.addEventListener('click', () => {
            body.classList.add('voting-popup_open');
            activeVoteButton = button;

            const isLike = button.classList.contains('like-popup-opner');
            const popupSelector = isLike ? '.voting-popup' : '.negative-voting-popup';
            const fieldSelector = isLike ? '#like_product_name' : '#dislike_product_name';

            const popup = document.querySelector(popupSelector);
            if (!popup) return;

            const productField = popup.querySelector(fieldSelector);
            if (productField) {
                productField.value = button.dataset.productName || '';
            }
            popup.classList.add('active');
            overlay?.classList.add('active');
        });
    });

    document.querySelectorAll('.popup-close-button').forEach((button) => {
        button.addEventListener('click', () => {
            body.classList.remove('voting-popup_open');
            const popup = button.closest('.main-voting-popup');
            popup?.classList.remove('active');
            overlay?.classList.remove('active');
        });
    });

    overlay?.addEventListener('click', () => {
        body.classList.remove('voting-popup_open');
        document.querySelectorAll('.main-voting-popup.active').forEach((popup) => {
            popup.classList.remove('active');
        });
        overlay.classList.remove('active');
    });

    // ===== Helper: show a small status message inside the popup =====
    function showFormMessage(form, text, isError) {
        let msgEl = form.querySelector('.voting-form-message');
        if (!msgEl) {
            msgEl = document.createElement('p');
            msgEl.className = 'voting-form-message';
            form.appendChild(msgEl);
        }
        msgEl.textContent = text;
        msgEl.style.color = isError ? '#E03333' : '#2E7D32';
        msgEl.style.marginTop = '10px';
        msgEl.style.fontSize = '14px';
    }

    // ===== Helper: hidden iframe (Google Form silent submit mate) =====
    function createHiddenIframe() {
        let iframe = document.getElementById('hidden_google_form_iframe');
        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.name = 'hidden_google_form_iframe';
            iframe.id = 'hidden_google_form_iframe';
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
        }
        return iframe;
    }

    // ===== Helper: Google Form ma silently submit karo =====
    function submitToGoogleForm(fullName, email, product, voteType) {
        createHiddenIframe();

        const formData = new FormData();
        formData.append(ENTRY_FULL_NAME, fullName);
        formData.append(ENTRY_EMAIL, email);
        formData.append(ENTRY_PRODUCT, product);
        formData.append(ENTRY_VOTE_TYPE, voteType);

        return fetch(GOOGLE_FORM_ACTION_URL, {
            method: 'POST',
            mode: 'no-cors', // Google Form CORS block kare chhe, e normal chhe
            body: formData,
        });
    }

    // ============================================
    // VOTE LOCK — 2 divas mate button disable (localStorage)
    // ============================================
    const VOTE_LOCK_KEY = 'product_vote_lock';
    const VOTE_LOCK_DAYS = 2;

    function getVoteLocks() {
        let locks = {};
        try {
            locks = JSON.parse(localStorage.getItem(VOTE_LOCK_KEY)) || {};
        } catch (err) {
            locks = {};
        }
        const now = Date.now();
        let changed = false;
        for (const key in locks) {
            if (locks[key].expires < now) {
                delete locks[key];
                changed = true;
            }
        }
        if (changed) localStorage.setItem(VOTE_LOCK_KEY, JSON.stringify(locks));
        return locks;
    }

    function setVoteLock(productName, voteType) {
        const locks = getVoteLocks();
        locks[productName] = {
            type: voteType,
            expires: Date.now() + VOTE_LOCK_DAYS * 24 * 60 * 60 * 1000,
        };
        localStorage.setItem(VOTE_LOCK_KEY, JSON.stringify(locks));
    }

    // Ek product par vote thai jay etle e product na BANNE buttons (like + dislike) disable karo
    function disableBothButtonsForProduct(productName) {
        document.querySelectorAll('.popup-opner-button').forEach((btn) => {
            if (btn.dataset.productName === productName) {
                btn.classList.add('disabled');
            }
        });
    }

    function applyVoteLocksOnLoad() {
        const locks = getVoteLocks();
        document.querySelectorAll('.popup-opner-button').forEach((btn) => {
            const name = btn.dataset.productName;
            if (!name) return;
            if (locks[name]) {
                btn.classList.add('disabled');
            }
        });
    }
    applyVoteLocksOnLoad();

    // ============================================
    // POSITIVE (LIKE) FORM
    // ============================================
    const positiveForm = document.getElementById('positive-voting-form');

    positiveForm?.addEventListener('submit', async (event) => {
        event.preventDefault();

        const fullName = positiveForm.querySelector('#like_full_name')?.value || '';
        const email = positiveForm.querySelector('#like_mailid')?.value || '';
        const productName = positiveForm.querySelector('#like_product_name')?.value || '';

        if (!email) {
            showFormMessage(positiveForm, 'Please enter a valid email address.', true);
            return;
        }

        const submitButton = positiveForm.querySelector('button[type="submit"]');
        const originalButtonText = submitButton ? submitButton.textContent : '';

        if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = 'Submitting...';
        }

        try {
            await submitToGoogleForm(fullName, email, productName, 'Like');

            if (activeVoteButton) {
                const name = activeVoteButton.dataset.productName;
                if (name) {
                    setVoteLock(name, 'Like');
                    disableBothButtonsForProduct(name);
                }
            }

            showFormMessage(positiveForm, 'Thank you! Your vote has been submitted.', false);
            positiveForm.reset();

            setTimeout(() => {
                body.classList.remove('voting-popup_open');
                document.querySelector('.voting-popup')?.classList.remove('active');
                overlay?.classList.remove('active');
            }, 1200);
        } catch (error) {
            console.error('Vote submission error:', error);
            showFormMessage(positiveForm, 'Something went wrong. Please try again.', true);
        } finally {
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = originalButtonText;
            }
        }
    });

    // ============================================
    // NEGATIVE (DISLIKE) FORM
    // ============================================
    const negativeForm = document.getElementById('negative-voting-form');

    negativeForm?.addEventListener('submit', async (event) => {
        event.preventDefault();

        const fullName = negativeForm.querySelector('#dislike_full_name')?.value || '';
        const email = negativeForm.querySelector('#dislike_mailid')?.value || '';
        const productName = negativeForm.querySelector('#dislike_product_name')?.value || '';

        if (!email) {
            showFormMessage(negativeForm, 'Please enter a valid email address.', true);
            return;
        }

        const submitButton = negativeForm.querySelector('button[type="submit"]');
        const originalButtonText = submitButton ? submitButton.textContent : '';

        if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = 'Submitting...';
        }

        try {
            await submitToGoogleForm(fullName, email, productName, 'Dislike');

            if (activeVoteButton) {
                const name = activeVoteButton.dataset.productName;
                if (name) {
                    setVoteLock(name, 'Dislike');
                    disableBothButtonsForProduct(name);
                }
            }

            showFormMessage(negativeForm, 'Thank you! Your vote has been submitted.', false);
            negativeForm.reset();

            setTimeout(() => {
                body.classList.remove('voting-popup_open');
                document.querySelector('.negative-voting-popup')?.classList.remove('active');
                overlay?.classList.remove('active');
            }, 1200);
        } catch (error) {
            console.error('Vote submission error:', error);
            showFormMessage(negativeForm, 'Something went wrong. Please try again.', true);
        } finally {
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = originalButtonText;
            }
        }
    });
});